import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CollaborationItem } from '../../models/collaboration.model';
import { CollaborationStatus } from '../../../../API';

@Component({
  selector: 'app-collaboration-view-dataset-modal',
  templateUrl: './collaboration-view-dataset-modal.component.html',
  styleUrls: ['./collaboration-view-dataset-modal.component.scss'],
})
export class CollaborationViewDatasetModalComponent {
  @Input() visible: boolean = false;
  @Input() collaboration: CollaborationItem | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  sponsorDatasetAllowedStatus = [CollaborationStatus.ACTIVE, CollaborationStatus.CLOSED, CollaborationStatus.ON_HOLD];

  closeModal(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  get canViewSponsorData(): boolean {
    return this.sponsorDatasetAllowedStatus.includes(this.collaboration?.status as CollaborationStatus);
  }
}
